import "../../utils/messages";
import { USER_MESSAGES, RESTORE_MESSAGES } from "../../utils/messages";
import { ClientMessage } from "../../utils/objects";

export function assignRestoreRequests(api) {
    /**********************************RESTORE********************************************/
    api.getRestores = async function (filter) {
        var params = "index=" + filter.limit + "&offset=" + filter.offset + "&searchPhrase=" + filter.restoreName;
        if (filter.id_pc != "") {
            params += "&pc=" + filter.id_pc
        }
        if (filter.id_group != "") {
            params += "&group=" + filter.id_group
        }
        if (filter.lastresult != "") {
            params += "&level=" + filter.result
        }


        var url = "/enterprise/restores?";
        /*if(idPC)
            url += "?id_computer=" + idPC;

        */
        var response = await api.get(url + params, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, RESTORE_MESSAGES.LIST_NOT_RETRIEVED);
                return {
                    restore_logs: [],
                    has_more: false
                };
            });
        return response;
    }
    api.getRestoreWithID = async function (idRestore, restoreName) {
        var response = await api.get('/enterprise/restires/' + idRestore, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, RESTORE_MESSAGES.NOT_RETRIEVED, { 0: restoreName });
                return null;
            });
        return response;
    }

    api.deleteRestore = async function (idRestore, restoreName) {
        var clientMessage = ClientMessage.success(RESTORE_MESSAGES.DELETED);

        var response = await api.delete('/enterprise/restores/' + idRestore, this.buildConfig())
            .then(res => {
                if (res.status == 400) {
                    clientMessage = ClientMessage.error(RESTORE_MESSAGES.NOT_DELETED, { 0: restoreName });
                    return false;
                }
                return true;
            })
            .catch(e => {
                this.checkError(e, RESTORE_MESSAGES.NOT_DELETED, { 0: restoreName });
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "restoremethods");

        return response;
    }

    /*
    
        var response=await api.delete('/accounts/users/'+id, this.buildConfig())
            .then(res => {
                if (res.status==400) {
                    clientMessage=ClientMessage.error(USER_MESSAGES.NOT_DELETED);
                    return false;
                }
                return true;
            })
            .catch(e => {
                clientMessage=this.checkError(e, USER_MESSAGES.NOT_DELETED, { 0: username });
                return false;
            });
    */

    //}
}
